import { supabase } from '../supabaseClient';

export const antennasService = {

  async getAll() {
    const { data, error } = await supabase
      .from('antennas')
      .select('*')
      .order('created_at', { ascending: true });
    if (error) throw error;
    return data;
  },

  async getByFacility(facilityId) {
    const { data, error } = await supabase
      .from('antennas')
      .select('*')
      .eq('facility_id', facilityId)
      .order('created_at', { ascending: true });
    if (error) throw error;
    return data;
  },

  async create(antenna) {
    // Never pass id — let Supabase auto-generate it
    const { data, error } = await supabase
      .from('antennas')
      .insert([{
        org_id:        antenna.org_id,
        facility_id:   antenna.facilityId   || antenna.facility_id,
        facility_name: antenna.facilityName || antenna.facility_name,
        location:      antenna.location,
        status:        antenna.status       || 'Online',
        last_ping:     new Date().toISOString(),
        reads:         antenna.reads        || 0,
        bridge_ip:     antenna.bridge_ip    || null,
        bridge_port:   antenna.bridge_port  || null,
        antenna_port:  antenna.antenna_port || null,
      }])
      .select()
      .single();
    if (error) throw error;
    return data;
  },

  async update(id, changes) {
    const { data, error } = await supabase
      .from('antennas')
      .update({
        location:      changes.location,
        status:        changes.status,
        facility_name: changes.facilityName || changes.facility_name,
        bridge_ip:     changes.bridge_ip    || changes.bridgeIp    || null,
        bridge_port:   changes.bridge_port  || changes.bridgePort  || null,
        antenna_port:  changes.antenna_port || changes.antennaPort || null,
      })
      .eq('id', id)
      .select()
      .single();
    if (error) throw error;
    return data;
  },

  async delete(id) {
    const { error } = await supabase.from('antennas').delete().eq('id', id);
    if (error) throw error;
  },

  async deleteByFacility(facilityId) {
    const { error } = await supabase.from('antennas').delete().eq('facility_id', facilityId);
    if (error) throw error;
  },

  async updateFacilityName(facilityId, facilityName) {
    const { error } = await supabase
      .from('antennas').update({ facility_name: facilityName }).eq('facility_id', facilityId);
    if (error) throw error;
  },
};
